import { getHumanReadableNameCellHelper } from "../../../../../../../utils";

import type { Order, Language } from "../../../../../../../services";

const cellProcessing = (
	item?: Order.Model["rate"],
	language?: Language,
): string => getHumanReadableNameCellHelper(item?.name, language);

export default cellProcessing;
